// Spinner Loader
function runSpinnerLoader() {
  const spinner_loader = document.querySelector('.spinner-loader');
  if (spinner_loader) {
    spinner_loader.classList.remove('hidden');
    spinner_loader.classList.add('flex');
  }
}

function hideSpinnerLoader() {
  const spinner_loader = document.querySelector('.spinner-loader');
  if (spinner_loader) {
    spinner_loader.classList.add('hidden');
    spinner_loader.classList.remove('flex');
  }
}

// Skeleton Animation
function showSkeleton() {
  const skeleton = document.querySelector('.byteex-cart-drawer-items-skeleton');
  const cart_items_container = document.querySelector('.byteex-cart-drawer-items');

  if (skeleton && cart_items_container) {
    skeleton.classList.remove('hidden');
    cart_items_container.classList.add('hidden');
  }
}

function hideSkeleton() {
  const skeleton = document.querySelector('.byteex-cart-drawer-items-skeleton');
  const cart_items_container = document.querySelector('.byteex-cart-drawer-items');

  if (skeleton && cart_items_container) {
    skeleton.classList.add('hidden');
    cart_items_container.classList.remove('hidden');
  }
}

// Cart Color Picker Listeners
function addCartColorChangeListeners(index, type) {
  const color_picker_modal = document.querySelector(`.picker-modal-${index}`);
  const sorry_label = color_picker_modal.previousElementSibling;
  const selected_colors = color_picker_modal.querySelectorAll('.byteex-cart-selected-color');
  const remove_color_buttons = color_picker_modal.querySelectorAll('.byteex-cart-remove-color');
  const colors_variants = color_picker_modal.querySelectorAll('.byteex-cart-color-item');
  const submit_button = color_picker_modal.querySelector('.byteex-cart-picker-submit');
  const colors_filters = color_picker_modal.querySelectorAll('.byteex-cart-color-filter');

  function filterColors(event) {
    const filter_button = event.currentTarget;
    const filter_value = filter_button.dataset.value;

    colors_filters.forEach((filter) => {
      filter.style.fontWeight = '400';
    });
    filter_button.style.fontWeight = '700';

    colors_variants.forEach((variant) => {
      const variant_filters = variant.dataset.filter.toLowerCase();

      variant.style.display = 'flex';
      if (!variant_filters.includes(filter_value) && filter_value != 'All') {
        variant.style.display = 'none';
      }
    });
  }

  function removeColorHandler(event) {
    const button = event.currentTarget;
    button.style.display = 'none';
    const parent = button.parentElement;
    parent.dataset.empty = 'true';
    parent.dataset.id = 'empty';
    parent.dataset.image = 'empty';
    parent.dataset.color = 'empty';

    const image_element = parent.querySelector('img');
    if (image_element) {
      image_element.style.display = 'none';
    }

    const text_element = parent.nextElementSibling;
    if (text_element) {
      text_element.textContent = '';
    }

    const out_of_stock_label = parent.querySelector('.out-of-stock-label');
    if (out_of_stock_label) {
      out_of_stock_label.style.display = 'none';
    }
  }

  function selectColorHandler(event) {
    const button = event.currentTarget;
    const id = button.dataset.id;
    const image = button.dataset.image;
    const color = button.dataset.color;

    for (const color_variant of selected_colors) {
      const is_empty = color_variant.dataset.empty;

      if (is_empty === 'true') {
        color_variant.dataset.id = id;
        color_variant.dataset.image = image;
        color_variant.dataset.color = color;

        const remove_button = color_variant.querySelector('.byteex-cart-remove-color');
        if (remove_button) {
          remove_button.style.display = 'block';
        }

        const image_element = color_variant.querySelector('img');
        if (image_element) {
          image_element.src = image;
          image_element.style.display = 'block';
        }

        const out_of_stock_label = color_variant.querySelector('.out-of-stock-label');
        if (out_of_stock_label) {
          out_of_stock_label.style.display = 'none';
        }

        const text_element = color_variant.nextElementSibling;
        if (text_element) {
          text_element.textContent = color;
        }

        color_variant.dataset.empty = 'false';
        break;
      }
    }
  }

  async function submitHandler(event) {
    const button = event.currentTarget;
    const key = button.dataset.key;

    let is_all_selected = true;
    let changes = {
      id: key,
      properties: {}
    };

    let index = 1;
    for (const color_variant of selected_colors) {
      const is_empty = color_variant.dataset.empty;

      if (is_empty === 'true') {
        is_all_selected = false;
        break;
      }

      changes.properties[`_id${index}.`] = color_variant.dataset.id;
      changes.properties[`_${index}.`] = color_variant.dataset.image;
      changes.properties[`${type} ${index}`] = color_variant.dataset.color;

      index++;
    }

    if (is_all_selected) {
      const text = button.querySelector('.byteex-cart-picker-submit-text');
      const loader = button.querySelector('.loader');

      text.style.display = 'none';
      loader.style.display = 'block';

      try {
        await fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(changes),
        });

        colors_filters.forEach((filter) => {
          filter.removeEventListener("click", filterColors);
        });

        remove_color_buttons.forEach((button) => {
          button.removeEventListener("click", removeColorHandler);
        });

        colors_variants.forEach((color_variant) => {
          color_variant.removeEventListener("click", selectColorHandler);
        });

        submit_button.removeEventListener("click", submitHandler);

        await syncCartGifts();

      } catch (error) {
        console.error("Error:", error);
      }
    }
  }

  function sorryLabelCloseHandler(event) {
    const button = event.currentTarget;
    if (button) {
      button.style.display = 'none';
    }
  }

  colors_filters.forEach((filter) => {
    filter.addEventListener("click", filterColors);
  });

  remove_color_buttons.forEach((button) => {
    button.addEventListener("click", removeColorHandler);
  });

  colors_variants.forEach((color_variant) => {
    color_variant.addEventListener("click", selectColorHandler);
  });

  if (submit_button) {
    submit_button.addEventListener("click", submitHandler);
  }

  if (sorry_label) {
    sorry_label.addEventListener("click", sorryLabelCloseHandler);
  }

  const nailPicker = document.querySelector(`.picker-${index}`);
  const overlay = document.querySelector('.cart-overlay');
  overlay.addEventListener('click', () => {
    colors_filters.forEach((filter) => {
      filter.removeEventListener("click", filterColors);
    });

    remove_color_buttons.forEach((button) => {
      button.removeEventListener("click", removeColorHandler);
    });

    colors_variants.forEach((color_variant) => {
      color_variant.removeEventListener("click", selectColorHandler);
    });

    submit_button.removeEventListener("click", submitHandler);

    sorry_label.removeEventListener('click', sorryLabelCloseHandler);

    nailPicker.style.display = 'none';
    overlay.style.display = 'none';
  });
}

// Cart Drawer Listeners
function addCartDrawerListeners() {
  // Quantity Buttons
  document.querySelectorAll(".quantity-btn").forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();

      runSpinnerLoader();
      showSkeleton();

      const parent = button.closest('.quantity-buttons-wrapper');
      const key = parent.closest('.cart-drawer-product-item').getAttribute("data-line-item-key");
      const quantityInput = parent.querySelector("input");

      const currentQuantity = quantityInput.value;
      const isUp = button.classList.contains("quantity-plus");
      const newQuantity = isUp ? +currentQuantity + 1 : +currentQuantity - 1;

      let updates = {
        [key]: newQuantity,
      };

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });

        if (!response.ok) {
          console.error("Cart update failed:", response.status);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        // A quantity change changes how many gift sets are due.
        await syncCartGifts();
      }
    });
  });

  // Close Cart Buttons
  document.querySelectorAll(".close_cart_btn").forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();

      if (cart_upsell_slider) {
        cart_upsell_slider.destroy();
        cart_upsell_slider = null;
      }

      document.documentElement.style.overflow = "unset";
      document.getElementById("byteex_cart_drawer").style.display = "none";
    });
  });

  // Checkout Button
  const checkout_button = document.getElementById('checkout_btn');
  if (checkout_button) {
    checkout_button.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const button = event.currentTarget;
      button.style.pointerEvents = "none";
      button.style.opacity = "0.5";

      await syncCartGifts();

      runSpinnerLoader();
      showSkeleton();

      const updated_button = document.getElementById('checkout_btn');
      updated_button.style.pointerEvents = "none";
      updated_button.style.opacity = "0.5";

      const selected_colors = document.querySelectorAll('.byteex-cart-selected-color');
      let is_empty = false;
      let empty_index;
      let empty_type;
      selected_colors.forEach((color) => {
        const empty_status = color.dataset.empty;

        if (empty_status === 'true') {
          is_empty = true;
          empty_index = color.dataset.index;
          empty_type = color.dataset.type;
        }
      });

      if (is_empty) {
        hideSpinnerLoader();
        hideSkeleton();

        const nailPicker = document.querySelector(`.picker-${empty_index}`);

        const sorryLabel = nailPicker.querySelector('.sorry-label');
        if (sorryLabel) {
          sorryLabel.style.display = 'block';
        }

        const overlay = document.querySelector('.cart-overlay');
        nailPicker.style.display = 'block';
        overlay.style.display = 'block';

        addCartColorChangeListeners(empty_index, empty_type);
      } else {
        // Reconcile instead of blindly re-adding the whole expected list: the
        // customer may be arriving back from checkout with the gifts gone, or may
        // already have them. Either way the cart ends up matching exactly once.
        (async () => {
          // Reconcile against freshly rendered markup, but skip the re-render — we
          // are leaving the page anyway.
          await syncCartGifts(false);

          // BREWAPP — off since 2026-09-04, Onward serves the drawer again. This recorded the
          // Checkout+ opt-in on the way out, and belongs on the redirect path rather than next
          // to the click: a picker validation failure above must not write an attribute for a
          // customer who never leaves the drawer. Sequential rather than parallel with
          // syncCartGifts, because both write to the same cart and concurrent writes can drop
          // one of the two.
          //
          // const brewappProtection = document.querySelector('brewapp-protection');
          // if (brewappProtection) {
          //   await brewappProtection.optIn();
          // }

          // Leave the drawer closed and the loaders off: Back restores this page
          // from the back-forward cache exactly as we leave it.
          resetDrawerUi();
          window.location.href = "/checkout";
        })();
      }
    });
  }

  // Delete Product from Cart
  const remove_buttons = document.querySelectorAll('.remove-cart-item');
  remove_buttons.forEach(button => {
    button.addEventListener('click', async (event) => {
      showSkeleton();
      runSpinnerLoader();

      const button = event.currentTarget;
      const id = button.dataset.key;

      let updates = {
        [id]: 0,
      };

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        });

        if (!response.ok) {
          console.error(`Cart update failed: ${response.status}`);
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        // Removing a product removes what earned its gifts. Without this the gift
        // lines stayed behind, invisible (they are not listed among the items and
        // the Free Gifts block is gone with the product), and rode along to
        // checkout with whatever was added next.
        await syncCartGifts();
      }
    });
  });

  // Delete Gel Set Product from Cart
  const remove_gel_set_buttons = document.querySelectorAll('.remove-gel-wrap-set');
  remove_gel_set_buttons.forEach(button => {
    button.addEventListener('click', async (event) => {
      showSkeleton();
      runSpinnerLoader();

      const button = event.currentTarget;
      const boxIndex = button.dataset.key;
      const keys_array = [];
      let updates = {};

      fetch("/cart.js")
        .then((res) => res.json())
        .then((data) => {
          const cartItems = data.items;

          cartItems.forEach((item) => {
            const props = item.properties || {};
            // != null, not a truthiness test: the first box in the cart has
            // _dynamicBoxIndex 0, which is falsy, so that box could never be removed.
            const itemBoxKey = props._dynamicBoxIndex != null ? props._dynamicBoxIndex : props._bundleId;

            // String compare: Loop box keys are GUIDs, and +GUID is NaN.
            if (itemBoxKey != null && String(itemBoxKey) === String(boxIndex)) {
              keys_array.push(item.key);
            }
          });

          keys_array.forEach(key => {
            updates[key] = 0;
          });

          fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates }),
          })
            .then((res) => res.json())
            .then(async (data) => {
              //console.log("✅ Successfully updated cart:", data);

              await syncCartGifts();
              hideSpinnerLoader();
              hideSkeleton();
            })
            .catch((err) => console.error("❌ Error adding to cart:", err));
        })
        .catch((err) => console.error("❌ Error adding to cart:", err));
    });
  });

  // Open Pedicure Colors Picker Buttons
  const pedicure_colors_picker_open_button = document.querySelector('.pedicure-colors-picker-open-button');
  const pedicure_colors_picker = document.querySelector('.pedicure-colors-picker');
  let pedicure_colors_array = [];
  if (pedicure_colors_picker_open_button) {
    pedicure_colors_picker_open_button.addEventListener('click', () => {
      pedicure_colors_picker.classList.remove('hidden');

      (function () {
        const el = document.querySelector('.pedicure-color-list-slider-wrapper');
        if (!el) return;

        console.log('run slider');

        const bar = document.querySelector('.pedicure-color-list-scrollbar');
        const track = bar.querySelector('.track');
        const thumb = bar.querySelector('.thumb');

        let isDown = false;
        let startX = 0;
        let startScrollLeft = 0;

        let velocity = 0;
        let lastX = 0;
        let lastTime = 0;
        let rafId = 0;
        let momentumRunning = false;

        const stopMomentum = () => {
          momentumRunning = false;
          cancelAnimationFrame(rafId);
        };

        const momentum = () => {
          momentumRunning = true;

          if (Math.abs(velocity) < 0.01) {
            momentumRunning = false;
            return;
          }
          el.scrollLeft -= velocity * 12;
          velocity *= 0.95;

          updateThumb();
          rafId = requestAnimationFrame(momentum);
        };

        el.addEventListener('dragstart', (e) => e.preventDefault());

        el.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return;
          isDown = true;
          el.classList.add('grabbing');

          bar.classList.add('active');

          startX = e.clientX;
          startScrollLeft = el.scrollLeft;
          velocity = 0;
          lastX = e.clientX;
          lastTime = Date.now();
          stopMomentum();
        });

        window.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const dx = e.clientX - startX;
          el.scrollLeft = startScrollLeft - dx;

          const now = Date.now();
          const dt = now - lastTime;
          if (dt > 0) velocity = (e.clientX - lastX) / dt;
          lastX = e.clientX;
          lastTime = now;

          updateThumb();
        }, { passive: false });

        const endDrag = () => {
          if (!isDown) return;
          isDown = false;
          el.classList.remove('grabbing');

          setTimeout(() => bar.classList.remove('active'), 120);

          if (Math.abs(velocity) > 0.08) momentum();
        };

        window.addEventListener('mouseup', endDrag);
        el.addEventListener('mouseleave', endDrag);

        function updateThumb() {
          const cw = el.clientWidth;
          const sw = el.scrollWidth;
          const sl = el.scrollLeft;

          if (sw <= cw) {
            thumb.style.width = '0px';
            thumb.style.transform = 'translateX(0)';
            return;
          }

          const trackW = track.clientWidth;
          const minThumb = 40;
          const thumbW = Math.max((cw / sw) * trackW, minThumb);
          const maxLeft = trackW - thumbW;
          const left = (sl / (sw - cw)) * maxLeft;

          thumb.style.width = thumbW + 'px';
          thumb.style.transform = `translateX(${left}px)`;
        }

        function syncBarWidth() {
          //const rect = el.getBoundingClientRect();
          //bar.style.width = rect.width + 'px';
          updateThumb();
        }

        el.addEventListener('scroll', () => {
          updateThumb();
        }, { passive: true });

        window.addEventListener('resize', syncBarWidth);

        if (typeof ResizeObserver !== 'undefined') {
          const ro = new ResizeObserver(() => syncBarWidth());
          ro.observe(el);
          ro.observe(track);
        } else {
          setTimeout(syncBarWidth, 60);
        }

        syncBarWidth();
        setTimeout(syncBarWidth, 250);
      })();
    });
  }

  function getPedicureColorItemCount(targetId) {
    return pedicure_colors_array.filter(id => id === targetId).length;
  }

  const pedicure_colors_picker_submit_button = document.querySelector('.pedicure-colors-picker-submit-button');

  // Add Pedicure Color Item Buttons
  const add_pedicure_color_items = document.querySelectorAll('.add-pedicure-color-item');
  add_pedicure_color_items.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const id = button.dataset.id;

      pedicure_colors_array.push(id);

      const current_quantity_wrapper = document.querySelector(`.quantity-pedicure-color-item-wrapper[data-id="${id}"]`);
      if (current_quantity_wrapper) {
        current_quantity_wrapper.classList.remove('hidden');
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = getPedicureColorItemCount(id);
      }

      const current_image_wrapper = document.querySelector(`.pedicure-picker-color-image-wrapper[data-id="${id}"]`);
      if (current_image_wrapper) {
        current_image_wrapper.classList.add('selected-pedicure-color-item');
      }

      pedicure_colors_picker_submit_button.textContent = pedicure_colors_picker_submit_button.dataset.addText;
      pedicure_colors_picker_submit_button.removeAttribute('disabled');
    });
  });

  // Plus Pedicure Color Item Buttons
  const plus_pedicure_color_items = document.querySelectorAll('.plus-pedicure-color-item');
  plus_pedicure_color_items.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const id = button.dataset.id;

      pedicure_colors_array.push(id);

      const current_quantity_wrapper = document.querySelector(`.quantity-pedicure-color-item-wrapper[data-id="${id}"]`);
      if (current_quantity_wrapper) {
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = getPedicureColorItemCount(id);
      }
    });
  });

  // Minus Pedicure Color Item Buttons
  const minus_pedicure_color_items = document.querySelectorAll('.minus-pedicure-color-item');
  minus_pedicure_color_items.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const id = button.dataset.id;

      const index = pedicure_colors_array.indexOf(id);
      if (index !== -1) {
        pedicure_colors_array.splice(index, 1);
      }

      const count = getPedicureColorItemCount(id);
      const current_quantity_wrapper = document.querySelector(`.quantity-pedicure-color-item-wrapper[data-id="${id}"]`);

      if (count <= 0) {
        current_quantity_wrapper.classList.add('hidden');
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = 0;

        const current_image_wrapper = document.querySelector(`.pedicure-picker-color-image-wrapper[data-id="${id}"]`);
        if (current_image_wrapper) {
          current_image_wrapper.classList.remove('selected-pedicure-color-item');
        }
      } else {
        current_quantity_wrapper.querySelector('.pedicure-color-item-count').textContent = count;
      }

      if (pedicure_colors_array.length === 0) {
        pedicure_colors_picker_submit_button.textContent = pedicure_colors_picker_submit_button.dataset.chooseText;
        pedicure_colors_picker_submit_button.disabled = true;
      }
    });
  });

  // Pedicure Colors Picker Submit Button  
  if (pedicure_colors_picker_submit_button) {
    pedicure_colors_picker_submit_button.addEventListener('click', () => {
      if (pedicure_colors_array.length > 0) {
        runSpinnerLoader();

        const formData = {
          items: pedicure_colors_array.map(id => ({
            id: id,
            quantity: 1
          }))
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            syncCartGifts();
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }

      pedicure_colors_picker.classList.add('hidden');
    });
  }

  // Close Pedicure Colors Picker Buttons
  const pedicure_colors_picker_close_buttons = document.querySelectorAll('.pedicure-colors-picker-close-button');
  if (pedicure_colors_picker_close_buttons) {
    pedicure_colors_picker_close_buttons.forEach(button => {
      button.addEventListener('click', () => {
        pedicure_colors_picker.classList.add('hidden');
      });
    });
  }

  // Add to Cart from Upsell Slider Buttons (drawer only — avoid stacking listeners on PDP / nail-picker buttons on each cart refresh)
  const cart_drawer_root = document.getElementById('byteex_cart_drawer');
  const cart_upsell_atc_buttons = cart_drawer_root
    ? cart_drawer_root.querySelectorAll('.cart-upsell-atc-button')
    : [];
  cart_upsell_atc_buttons.forEach(button => {
    button.addEventListener('click', async (event) => {
      showSkeleton();
      runSpinnerLoader();

      const button = event.currentTarget;
      const id = button.dataset.id;

      event.preventDefault();

      let formData = {
        items: [
          {
            id: id,
            quantity: 1,
          },
        ],
      };

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          console.error(`Cart add error: ${response.status}`);
        }

      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        await syncCartGifts();
      }
    });
  });

  // Choose Colors Buttons
  const choose_colors_buttons = document.querySelectorAll('.cart-upsell-choose-colors-button');
  choose_colors_buttons.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const choose_colors_element = button.nextElementSibling;
      choose_colors_element.style.display = 'block';

      // Choose Colors Add Buttons
      let colors_array = [];
      const choose_colors_add_buttons = choose_colors_element.querySelectorAll('.cart-upsell-color-add');
      choose_colors_add_buttons.forEach(button => {
        button.addEventListener('click', (event) => {
          const button = event.currentTarget;
          const id = button.dataset.id;
          const is_added = button.dataset.added;

          if (is_added === 'false') {
            colors_array.push(id);
            button.style.backgroundColor = '#000000';
            button.style.color = '#fff';
            button.querySelector('.cart-upsell-color-add-text').classList.add('hidden');
            button.querySelector('.cart-upsell-color-added-text').classList.remove('hidden');
            button.dataset.added = 'true';
          } else {
            button.style.backgroundColor = '#ffffff';
            button.style.color = '#000000';
            button.querySelector('.cart-upsell-color-add-text').classList.remove('hidden');
            button.querySelector('.cart-upsell-color-added-text').classList.add('hidden');
            button.dataset.added = 'false';
            colors_array = colors_array.filter(color => color !== id);
          }
        });
      });

      // Choose Colors Submit Buttons
      const choose_colors_submit_buttons = choose_colors_element.querySelectorAll('.cart-upsell-choose-colors-submit-button');
      choose_colors_submit_buttons.forEach(button => {
        button.addEventListener('click', (event) => {
          const button = event.currentTarget;
          const block_id = button.dataset.blockId;

          if (colors_array.length > 0) {
            runSpinnerLoader();

            const formData = {
              items: colors_array.map(id => ({
                id: id,
                quantity: 1
              }))
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              .then((response) => {
                syncCartGifts();
                return response.json();
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          }

          choose_colors_element.style.display = 'none';
          const block_element = document.querySelector(`.${block_id}`);
          block_element.style.display = 'none';
        });
      });
    });
  });

  // Open Colors Change Buttons for Nail Picker
  const open_color_change_buttons = document.querySelectorAll('.open-color-change');
  open_color_change_buttons.forEach(button => {
    button.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const index = button.dataset.index;
      const type = button.dataset.type;

      const nailPicker = document.querySelector(`.picker-${index}`);
      const overlay = document.querySelector('.cart-overlay');
      nailPicker.style.display = 'block';
      overlay.style.display = 'block';

      addCartColorChangeListeners(index, type);
    });
  });
}

// Puts the drawer back into a clean, closed state. Needed because leaving for
// /checkout freezes the drawer mid-load: pressing Back restores the page from the
// back-forward cache exactly as it was — spinner and skeleton still running, and no
// script re-runs to clear them.
function resetDrawerUi() {
  hideSpinnerLoader();
  hideSkeleton();

  const drawer = document.getElementById('byteex_cart_drawer');
  if (drawer) drawer.style.display = 'none';

  document.documentElement.style.overflow = 'unset';
}

// Fires on a normal load AND on a back-forward cache restore (event.persisted),
// which is the only hook that runs at all in the restore case. Only the restore
// needs a fresh count: the cart may have changed at checkout while no script of
// ours was running. On a normal load the count was already taken below, so the
// bubble is only re-asserted.
//
// The reset runs on a restore only. On a normal load pageshow fires after `load`,
// so a drawer the customer had already opened from the header was closed under them.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    resetDrawerUi();
    updateCartItemCount();
  } else {
    reassertCartItemCount();
  }
});

// Update Cart Items Count in Header.
//
// Working out the number and writing it into the DOM are kept apart on purpose.
// Callers that already hold a fresh cart pass it in instead of asking for another
// one, and re-asserting the bubble over section scripts costs no request at all.
let lastCartItemCount = null;
let cartItemCountInFlight = null;

// Count only paid products (price not 0), excluding "Checkout" items
function countPaidCartItems(cart) {
  return ((cart && cart.items) || []).reduce((sum, item) => {
    if (item.price === 0 || item.title.includes('Checkout')) {
      return sum;
    }
    return sum + item.quantity;
  }, 0);
}

function renderCartItemCount(count) {
  const items_count_element = document.querySelector('.cart_items_counter');
  if (!items_count_element) return;

  const items_count_element_wrapper = items_count_element.parentElement;

  if (count > 0) {
    items_count_element_wrapper.classList.remove('hidden');
    items_count_element_wrapper.classList.add('flex');
    items_count_element.textContent = count;
  } else {
    items_count_element_wrapper.classList.add('hidden');
    items_count_element_wrapper.classList.remove('flex');
  }
}

// Pass a cart already fetched elsewhere to skip the request entirely. Without one,
// concurrent calls share a single /cart.js instead of each firing their own.
async function updateCartItemCount(cart) {
  if (cart) {
    lastCartItemCount = countPaidCartItems(cart);
    renderCartItemCount(lastCartItemCount);
    return;
  }

  if (cartItemCountInFlight) return cartItemCountInFlight;

  cartItemCountInFlight = (async () => {
    try {
      const fresh = await fetch('/cart.js').then((r) => r.json());
      lastCartItemCount = countPaidCartItems(fresh);
      renderCartItemCount(lastCartItemCount);
    } catch (error) {
      console.error('Error updating cart item count:', error);
    } finally {
      cartItemCountInFlight = null;
    }
  })();

  return cartItemCountInFlight;
}

// Writes the last known number again without touching the network. Section scripts
// publish their own raw item_count shortly after load (gifts included), so the
// bubble has to be re-asserted — but the number itself has not changed by then.
// If nothing is known yet (first read failed, or is still in flight) it asks for the
// cart — an in-flight read is shared, so that costs no extra request.
function reassertCartItemCount() {
  if (lastCartItemCount === null) return updateCartItemCount();
  renderCartItemCount(lastCartItemCount);
}

// Fetches the drawer markup for the current cart WITHOUT showing it. Returns the
// element, or null. Kept separate so callers can read the freshly rendered state
// (the expected gift set, for one) and decide what to display — showing markup
// twice for a single open is visible to the customer.
async function fetchCartDrawerMarkup() {
  const locale = Shopify?.locale;
  const localePrefix = locale && locale !== 'en' ? `/${locale}` : '';

  // section_id is the documented Section Rendering API parameter and returns just
  // this section, instead of the whole page. The old ?section= was not a parameter
  // Shopify honours, so every refresh rendered the home page and picked the drawer
  // out of it. The id comes from the section itself: inside a section group it is
  // prefixed (sections--…__byteex-cart-drawer), not the bare key.
  const drawerEl = document.querySelector('.byteex_cart_drawer');
  const sectionId = (drawerEl && drawerEl.dataset.sectionId) || '';

  const parse = async (url) => {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Cart loading error: ${res.status}`);

    const html = document.createElement('div');
    html.innerHTML = await res.text();

    return html.querySelector('.byteex_cart_drawer');
  };

  if (sectionId) {
    try {
      const markup = await parse(`${localePrefix}/?section_id=${encodeURIComponent(sectionId)}`);
      if (markup) return markup;
    } catch (error) {
      console.warn('Section render failed, falling back to a full page render:', error);
    }
  }

  // Fallback: render a page and take the drawer out of it, as before.
  return parse(`${localePrefix}/`);
}

// Every cart change can invalidate the gift set: removing a product removes what
// earned its gifts, and a quantity change changes how many sets are due. Call this
// after any mutation instead of re-rendering directly.
//
// The order matters. The expected set is computed server-side, so it has to be read
// from markup rendered AFTER the mutation — reading the markup still on the page
// would compare against the cart as it was. And the markup is fetched before it is
// shown, so the customer sees the drawer fill in once, not twice.
let cartSyncInFlight = null;
let cartSyncRepeat = false;

async function syncCartGifts(render) {
  // Calls that arrive while a sync is running are coalesced into one more pass of
  // the running one. Without this, two cart mutations in quick succession (or two
  // handlers reacting to the same click) each render, and the customer sees the
  // drawer load twice.
  if (cartSyncInFlight) {
    cartSyncRepeat = true;
    return cartSyncInFlight;
  }

  cartSyncInFlight = (async () => {
    let markup = null;
    let cart = null;

    do {
      cartSyncRepeat = false;

      try {
        markup = await fetchCartDrawerMarkup();
      } catch (error) {
        console.error('Error fetching cart drawer markup:', error);
      }

      let changed = false;
      try {
        const reconciled = await window.reconcileGifts(markup);
        changed = !!(reconciled && reconciled.changed);
        cart = (reconciled && reconciled.cart) || null;
      } catch (error) {
        console.error('Error reconciling gifts:', error);
      }

      if (changed) {
        try {
          markup = await fetchCartDrawerMarkup();
        } catch (error) {
          console.error('Error fetching cart drawer markup:', error);
        }
      }
    } while (cartSyncRepeat);

    // One render, always the final state — never an intermediate one.
    if (render === false) return;

    await updateCartDrawer(markup);
    // The header count is taken from the cart the reconcile already fetched. Its
    // own mutations only ever touch $0 lines, which the count ignores, so that
    // snapshot still holds — one /cart.js less per interaction. If the fetch in
    // there failed, cart is null and this falls back to asking for it.
    await updateCartItemCount(cart);
  })();

  try {
    await cartSyncInFlight;
  } finally {
    cartSyncInFlight = null;
  }
}

// Update Cart Drawer. Pass markup already fetched by fetchCartDrawerMarkup() to
// display it without fetching again.
//
// Only syncCartGifts() calls this, and it updates the header count right after —
// so this does not touch the count itself. Keep it that way: a call from here
// would be a second /cart.js for the same state.
async function updateCartDrawer(prefetchedMarkup) {
  if (cart_upsell_slider) {
    cart_upsell_slider.destroy();
    cart_upsell_slider = null;
  }

  try {
    showSkeleton();
    runSpinnerLoader();

    const newContentEl = prefetchedMarkup || (await fetchCartDrawerMarkup());
    const currentDrawer = document.querySelector(".byteex_cart_drawer");

    if (newContentEl && currentDrawer) {
      currentDrawer.innerHTML = newContentEl.innerHTML;
      addCartDrawerListeners();
    } else {
      console.warn("Could not find .byteex_cart_drawer in the new or current HTML");
    }
  } catch (error) {
    console.error("Error in updateCartDrawer:", error);
  } finally {
    hideSpinnerLoader();

    const slider_container = document.getElementById('keen-upsell-slider');
    if (slider_container) {
      cart_upsell_slider = new KeenSlider(
        "#keen-upsell-slider",
        {
          loop: false,
          slides: {
            spacing: 1,
            perView: 1,
          },
        },
        [cart_upsell_navigation]
      );
    }

    hideSkeleton();

    const cart_drawer_product_titles = document.querySelectorAll('.cart-drawer-product-title');
    cart_drawer_product_titles.forEach(title => {
      const title_text = title.querySelector('p');
      const title_blur = title.querySelector('div');
      const title_height = title_text.offsetHeight;

      if (title_height > 42) {
        title_blur.classList.remove('hidden');
      }
    });

    const cart_drawer_upsell_product_titles = document.querySelectorAll('.cart-drawer-upsell-product-title');
    cart_drawer_upsell_product_titles.forEach(title => {
      const title_text = title.querySelector('p');
      const title_blur = title.querySelector('div');
      const title_height = title_text.offsetHeight;

      if (title_height > 21) {
        title_blur.classList.remove('hidden');
      }
    });
  }
}

// Function to add event listeners to Add to Cart forms
function addToCartFormListeners() {
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  addToCartForms.forEach((form) => {
    // Remove existing listeners to avoid duplicates
    form.removeEventListener("submit", handleAddToCartSubmit);
    form.addEventListener("submit", handleAddToCartSubmit);
  });
}

// Handle Add to Cart form submission
async function handleAddToCartSubmit(event) {
  showSkeleton();
  runSpinnerLoader();

  event.preventDefault();
  const form = event.currentTarget
  const productType = form.dataset.productType;

  const loader = form.querySelector(".loader");
  const buttonText = form.querySelector(".atc_button_text");
  const priceAtc = form.querySelector(".price-atc");
  const priceAtcArrow = form.querySelector(".price-atc-arrow");
  const atc_button_text = document.getElementById('atc-button-text');

  const stickyLoader = document.getElementById("sticky_atc_button_loader");
  const stickyButtonText = document.getElementById("sticky_atc_button_text");

  if (atc_button_text) {
    atc_button_text.style.display = "none";
  }

  if (priceAtc) {
    priceAtc.style.display = "none";
  }

  if (priceAtcArrow) {
    priceAtcArrow.style.display = "none";
  }

  if (buttonText) {
    buttonText.style.display = "none";
  }

  if (loader) {
    loader.style.display = "block";
  }

  if (stickyButtonText) {
    stickyButtonText.style.display = "none";
  }

  if (stickyLoader) {
    stickyLoader.style.display = "block";
  }

  // Add to cart form
  const body = new FormData(form);

  const res = await fetch("/cart/add", {
    method: "post",
    body: body,
  })
    .then(async () => {
      // Removal the data on product pages
      if (productType === "at-home-nail-manicure-kit") {
        window.clearNailPicker();
      } else if (productType === "nail-picker-6-redesing") {
        window.clearNailPicker6Redesign();
      } else if (productType === "nail-picker-3-redesing") {
        window.clearNailPicker3Redesign();
      } else if (productType === "nail-picker-updated") {
        window.clearNailPickerUpdated();
      } else if (productType === "nail-picker-gel-wraps") {
        window.clearNailPickerGelWraps();
      } else if (productType === "new-nail-picker") {
        window.clearNewNailPicker();
      } else if (productType === "two-nail-picker-on-page") {
        window.clearTwoNailPickerOnPage();
      } else if (productType === "default") {
        if (atc_button_text) {
          atc_button_text.style.display = "flex";
        }
      }

      if (buttonText) {
        buttonText.style.display = "flex";
      }

      if (priceAtc) {
        priceAtc.style.display = "flex";
      }

      if (loader) {
        loader.style.display = "none";
      }

      if (stickyButtonText) {
        stickyButtonText.style.display = "inline";
      }

      if (stickyLoader) {
        stickyLoader.style.display = "none";
      }

      syncCartGifts();

      if (
        !form.classList.contains("upsell_form") &&
        !form.classList.contains("addon_form") &&
        !form.classList.contains("pre-cart-form")
      ) {
        onOpenDrawer();
      }
    })
    .catch((error) => console.error("Error adding to cart:", error));
}

addToCartFormListeners();

// Update the cart counter on page load: one /cart.js immediately, so the bubble is
// correct straight away, then the same number written again after 3s to win over
// section scripts that publish their own raw item_count. The re-assertion needs no
// request — the count is already known. pageshow above covers Back / bfcache.
updateCartItemCount();
setTimeout(reassertCartItemCount, 3000);

// Gifts are $0 line items and they are DERIVED state: what the cart should hold
// is computed server-side into .data-cart-gifts-ids — metafield gifts (per unit,
// which is how the serum templates configure theirs), mystery gifts by threshold,
// and one set per build-a-box. This function makes the cart match that list: it
// adds what is missing, trims duplicates, and removes gifts whose product is no
// longer in the cart.
//
// Only absolute quantities are used, so running it twice changes nothing — which
// is what the old "wipe every $0 line on open, add them again at the checkout
// button" pair could not promise, and why box orders lost their gifts entirely.
//
// A $0 line is the criterion for "this is a gift", the same test the wipe used.
window.readExpectedGifts = function (root) {
  const el = (root || document).querySelector('.data-cart-gifts-ids');
  const expected = new Map();
  if (!el) return expected;

  String(el.dataset.cartGiftsIds || '')
    .split(',')
    .map((id) => Number(id.trim()))
    .filter((id) => id > 0)
    .forEach((id) => expected.set(id, (expected.get(id) || 0) + 1));

  return expected;
};

// Returns { changed, cart }: whether the cart was written to, and the cart as it was
// read here. Callers reuse that snapshot instead of fetching /cart.js again — it
// stays valid for anything that ignores $0 lines, which is all this function moves.
window.reconcileGifts = async function (root) {
  const target = window.readExpectedGifts(root);
  let changed = false;

  let cart;
  try {
    cart = await fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json());
  } catch (error) {
    return { changed: false, cart: null };
  }
  const items = (cart && cart.items) || [];

  const freeLines = items.filter((item) => item.original_price === 0);
  if (target.size === 0 && freeLines.length === 0) return { changed, cart };

  const present = new Map();
  freeLines.forEach((line) => {
    present.set(line.variant_id, (present.get(line.variant_id) || 0) + line.quantity);
  });

  // Trim first: a surplus line can be the same variant we would otherwise add.
  for (const line of freeLines) {
    const want = target.get(line.variant_id) || 0;
    const have = present.get(line.variant_id) || 0;
    if (have <= want) continue;

    const keep = Math.max(0, line.quantity - (have - want));
    if (keep === line.quantity) continue;

    try {
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: keep })
      });
      present.set(line.variant_id, have - (line.quantity - keep));
      changed = true;
    } catch (error) {
      console.error('Error trimming gifts:', error);
    }
  }

  const missing = [];
  target.forEach((want, variantId) => {
    const have = present.get(variantId) || 0;
    if (want > have) {
      missing.push({
        id: variantId,
        quantity: want - have,
        properties: { _gift: 'true' }
      });
    }
  });

  if (missing.length) {
    try {
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: missing })
      });
      changed = true;
    } catch (error) {
      console.error('Error restoring gifts:', error);
    }
  }

  return { changed, cart };
};

// Refreshes the cart when the drawer is opened (called from onOpenDrawer)
// to display the real cart and not the one from the cache
window.refreshCartOnOpen = function () {
  runSpinnerLoader();
  showSkeleton();

  fetch('/cart.js', { cache: 'no-store' })
    .then(res => res.json())
    .then(cart => {
      const updates = {};
      // $0 lines are no longer wiped here: window.reconcileGifts() below owns them,
      // adding what is expected and removing what is not. Wiping them on every open
      // is what lost the gifts on box orders — nothing restored them afterwards.
      // The Checkout+ line keeps its old handling: removed here, re-added by whichever
      // protection app is active. Onward and Brewapp both name their product "Checkout+",
      // so the title test covers both while the two run in parallel — deliberately left
      // matching on the title rather than narrowed to Brewapp's
      // product_type 'btx_shipping_protection'.
      //
      // This is also what clears a stale line after an abandoned checkout: the app adds a
      // real product to the cart, and without this it would still be there (and get added
      // a second time) when the customer comes back and reopens the drawer.
      cart.items.forEach(item => {
        if (item.title.includes('Checkout')) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        return null;
      }

      return fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      }).then(r => {
        if (!r.ok) throw new Error('Error updating cart');
        return r.json();
      });
    })
    .then(async () => {
      // After a Back the markup on the page is the cart as it was before checkout,
      // so the expected set is read from freshly fetched markup, not from the page.
      showSkeleton();
      runSpinnerLoader();

      await syncCartGifts();
    })
    .catch(err => {
      console.error('Error processing cart:', err);

      // BTF: a failed /cart.js or /cart/update.js (e.g. 429) used to leave the
      // spinner overlay up for good. It covers the close and checkout buttons and
      // the page stays scroll-locked, so the whole site looked frozen. Clear the
      // loaders so the drawer is usable, then try one fresh sync after a short wait.
      hideSpinnerLoader();
      hideSkeleton();
      setTimeout(() => { syncCartGifts(); }, 1500);
    });
};
